import { CUSTOMER_JOURNEY_EVENTS_CATEGORY_SUCCESS } from './../const';

function action(data) {
  return { type: CUSTOMER_JOURNEY_EVENTS_CATEGORY_SUCCESS, data };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyEventsCategorySuccess.js